module.exports = __webpack_public_path__ + "static/media/integrationsActive.e85f80a1.svg";